import { FoaPart } from "../../../../../autogen/bff-api";

export type EspdRequirement =
  | { required: "unknown" }
  | { required: true; value: string }
  | { required: false; value: string };

// ESPD is required for Part III (over the EEA threshold) and Part IV (special services).
// foaPart is server-derived from estimated value + contract nature (FoaPartClassifier), so
// this gate stays consistent with the FOA part rendered elsewhere in the wizard.
export function computeEspdRequirement(
  foaPart: FoaPart | null | undefined,
  estimatedValueNok: number | null | undefined,
): EspdRequirement {
  if (foaPart == null || estimatedValueNok == null) {
    return { required: "unknown" };
  }
  const value = formatNok(estimatedValueNok);
  if (foaPart === FoaPart.PartIii || foaPart === FoaPart.PartIv) {
    return { required: true, value };
  }
  return { required: false, value };
}

function formatNok(value: number): string {
  return new Intl.NumberFormat("nb-NO", {
    style: "currency",
    currency: "NOK",
    maximumFractionDigits: 0,
  }).format(value);
}
